export default (api) => {
  api.notification = {
    public: {
    },
    memberConsole: {
      unread: () => api.request({
        url: `/api/member-console/member-notification/unread`,
        type: 'get',
      }),
      index: (params = null) => api.request({
        url: `/api/member-console/member-notification/index`,
        type: 'get',
        params,
      }),
      listIndex: (page = 1) => api.request({
        url: `/api/member-console/member-notification/index`,
        type: 'get',
        params: {
          page,
          per: 10,
          sort: { created_at: 'desc' },
        },
      }),
      batchMarkAsRead: (params) => api.request({
        url: `/api/member-console/member-notification/mark-as-read`,
        type: 'put',
        params,
      }),
    },
  }
}